import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';
import { untrustedWsAppApiController } from 'APP/wsApi/wsAppApi/untrustedWsAppApi/UntrustedWsAppApi';

import { wsAppApiController } from './wsAppApi/WsAppApi';

let isWsApiInitialized = false;
let isWsUntrustedApiInitialized = false;

export function wsApiConnect(session: string, refreshToken: () => Promise<string | null>): void {
  if (!isWsApiInitialized) {
    wsAppApiController.connect(session, ProjectUrls.wsApiUrl);
    wsAppApiController.refreshToken = refreshToken;

    isWsApiInitialized = true;
  }
}

export function wsApiDisconnect(): void {
  if (isWsApiInitialized) {
    wsAppApiController.disconnect();

    isWsApiInitialized = false;
  }
}

export function wsUntrustedApiConnect(
  session: string,
  refreshToken: () => Promise<string | null>
): void {
  if (!isWsUntrustedApiInitialized) {
    untrustedWsAppApiController.connect(session, `${ProjectUrls.wsApiUrl}/untrusted`, true);
    untrustedWsAppApiController.refreshToken = refreshToken;

    isWsUntrustedApiInitialized = true;
  }
}

export function wsUntrustedApiDisconnect(): void {
  if (isWsUntrustedApiInitialized) {
    untrustedWsAppApiController.disconnect();

    isWsUntrustedApiInitialized = false;
  }
}
